import { FilterIcon } from '@heroicons/react/solid';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useDetectClickOutside } from 'react-detect-click-outside';

import DownArrow from '../../svgs/DownArrow';
import useOnClickOutside from '../../../hooks/useClickOutside';
import Lens from '../../svgs/Lens';

const TidalDashboardAddBotKeySearchInputWrapper = styled.button`
  border: 1px solid ${(props) => props.theme.colors.borderColors[0]};
  border-radius: 10px;
  background-color: ${(props) => props.theme.colors.secondary};
  height: 42px;
  width: 100%;
  display: grid;
  grid-template-columns: 21px 1fr 12px;
  grid-gap: 0 10px;
  align-items: center;
  padding: 0 13px;
  cursor: pointer;
  position: relative;
  input {
    height: 100%;
    outline: none;
    background-color: ${(props) => props.theme.colors.secondary};
  }
  & > .selected-item {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: ${(props) => props.theme.colors.text[1]};
    display: flex;
    justify-content: flex-start;
  }
`;

const TidalDashboardAddBotKeySearchInputMenuContainer = styled.div<{
  isVisible: boolean;
}>`
  border: ${(props) =>
    props.isVisible
      ? `1px solid ${props.theme.colors.borderColors[0]}`
      : 'none'};
  border-radius: 10px;
  box-shadow: 0px 10px 49px rgb(0 27 31 / 12%);
  position: absolute;
  top: 50px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.secondary};
  max-height: 200px;
  height: 0px;
  overflow: auto;
  z-index: 1;
  padding: ${(props) => (props.isVisible ? '8px' : '0 8px')};
  transition: all 0.2s ease-in-out;
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
`;

const TidalDashboardAddBotKeySearchInputMenuItem = styled.div<{
  isDropDownOpened: boolean;
}>`
  height: 20px;
  width: 100%;
  border-radius: 4px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #000;
  font-size: 14px;
  grid-gap: 0 8px;
  font-weight: 500;
  visibility: ${(props) => (props.isDropDownOpened ? 'visible' : 'hidden')};
  img {
    height: 16px;
    width: 16px;
    border-radius: 5px;
  }
  &:hover {
    background-color: ${(props) => `${props.theme.colors.accent}80`};
    color: #fff;
  }
`;

interface ITidalDashboardAddBotKeySearchInput {
  label: string;
  items: any[];
  onSelect: (item: any) => void;
}

const TidalDashboardAddBotKeySearchInput = ({
  label,
  items,
  onSelect,
}: ITidalDashboardAddBotKeySearchInput): JSX.Element => {
  const [filteredItems, setFilteredItems] = useState(items);
  const [selectedItem, setSelectedItem] = useState(items[0].name);
  const [isDropdownOpened, setIsDropDownOpened] = useState(false);
  const dropdownMenuRef = useRef<any>();

  const ref = useRef();
  const searchRef = useRef<any>();
  useOnClickOutside(ref, () => {
    if (isDropdownOpened) handleDropDownToggle();
  });

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const handleDropDownToggle = async () => {
    try {
      if (!isDropdownOpened) {
        dropdownMenuRef.current.style.height = '200px';
        await sleep(100);
        setIsDropDownOpened(true);
      } else {
        dropdownMenuRef.current.style.height = '0px';
        await sleep(10);
        setIsDropDownOpened(false);
      }
    } catch (e) {}
  };

  const handleItemSelect = (item) => {
    searchRef.current.value = '';
    searchRef.current.placeholder = item.name;
    setFilteredItems(items);
    setSelectedItem(item.name);
    handleDropDownToggle();
    onSelect(item);
  };

  const handleFilter = (e) => {
    try {
      const bots = items.filter((bot) =>
        bot.name.toLowerCase().includes(e.target.value.toLowerCase()),
      );
      setFilteredItems(bots);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    setFilteredItems(items);
  }, [items]);

  return (
    <TidalDashboardAddBotKeySearchInputWrapper
      ref={ref}
      onClick={() => {
        handleDropDownToggle();
      }}
    >
      <div>
        <Lens />
      </div>
      <input
        className="selected-item"
        onChange={handleFilter}
        ref={searchRef}
      />
      <TidalDashboardAddBotKeySearchInputMenuContainer
        isVisible={isDropdownOpened}
        ref={dropdownMenuRef}
      >
        {filteredItems.map((item, key) => (
          <TidalDashboardAddBotKeySearchInputMenuItem
            key={key}
            onClick={(e) => {
              e.stopPropagation();
              handleItemSelect(item);
            }}
            isDropDownOpened={isDropdownOpened}
          >
            <img alt="" src={`/assets/dashboard/bots/${item.image_url}`} />
            {item.name}
          </TidalDashboardAddBotKeySearchInputMenuItem>
        ))}
      </TidalDashboardAddBotKeySearchInputMenuContainer>
    </TidalDashboardAddBotKeySearchInputWrapper>
  );
};

export default TidalDashboardAddBotKeySearchInput;
